import { render, staticRenderFns } from "./MenuManage.vue?vue&type=template&id=34b4ce18&scoped=true&"
import script from "./MenuManage.vue?vue&type=script&lang=js&"
export * from "./MenuManage.vue?vue&type=script&lang=js&"
import style0 from "./MenuManage.vue?vue&type=style&index=0&id=34b4ce18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b4ce18",
  null
  
)

export default component.exports